var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 6.66667V9.33333H6.66667V6.66667H9.33333ZM10.6667 6.66667H14V9.33333H10.6667V6.66667ZM9.33333 14H6.66667V10.6667H9.33333V14ZM10.6667 14V10.6667H14V13.3333C14 13.7015 13.7015 14 13.3333 14H10.6667ZM9.33333 2V5.33333H6.66667V2H9.33333ZM10.6667 2H13.3333C13.7015 2 14 2.29848 14 2.66667V5.33333H10.6667V2ZM5.33333 6.66667V9.33333H2V6.66667H5.33333ZM5.33333 14H2.66667C2.29848 14 2 13.7015 2 13.3333V10.6667H5.33333V14ZM5.33333 2V5.33333H2V2.66667C2 2.29848 2.29848 2 2.66667 2H5.33333Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridFill);
export default __webpack_public_path__ + "static/media/gridFill.e9d9ad5698954ea76ed53348344d3bb7.svg";
export { ForwardRef as ReactComponent };